export const iconFontAwesomeEnergyChargingStation = (
	<i className="fa-solid fa-charging-station"></i>
);
